// hooks/useCategoryFilter.ts
import { useState } from "react";
import { SelectProduct, StylingStaff } from "../types/salon.types";

export const useCategoryFilter = (
  products: SelectProduct[],
  activeTab: "Staffs" | "Services",
  selectedStaff: StylingStaff | null
) => {
  const [filterProducts, setFilterProducts] = useState<SelectProduct[]>([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState<string | null>(null);

  // Handle selecting category
  const handleCategorySelect = (categoryId: string) => {
    setSelectedCategoryId(categoryId);

    // Filter products by category
    const productFilter = products.filter((p) => p.category_id === categoryId);

    // If active tab is staff and staff is selected, filter by staff list
    if (activeTab === "Staffs" && selectedStaff) {
      const staffProducts = productFilter.filter(
        (p) =>
          Array.isArray(p.staff_list) &&
          p.staff_list.includes(selectedStaff.staff_name)
      );

      setFilterProducts(staffProducts);
      return;
    }

    // Default filtering
    setFilterProducts(productFilter);
  };

  // Reset category filter completely
  const resetCategoryFilter = () => {
    setFilterProducts([]);
    setSelectedCategoryId(null);
  };

  return {
    filterProducts,
    selectedCategoryId,
    handleCategorySelect,
    resetCategoryFilter,
  };
};
